import { Trans, useTranslation } from 'react-i18next'
import { Modal, ActionModal } from '@percent/lemonade'
import { useCancelOpportunity } from './useCancelOpportunity'

export type CancelOpportunityModalProps = Readonly<{
  isOpen: boolean
  onClose: () => void
  opportunityId: string
  opportunityName: string
  onSuccess?: () => void
  onError: (error: Record<'code' | 'message' | 'title', string>) => void
}>

export function CancelOpportunityModal({
  isOpen,
  onClose,
  opportunityName,
  opportunityId,
  onSuccess,
  onError
}: CancelOpportunityModalProps) {
  const { t } = useTranslation()

  const { isLoading, cancelOpportunity } = useCancelOpportunity({
    opportunityId,
    onCancelled: onSuccess,
    onError
  })

  return (
    <Modal open={isOpen} onClose={onClose}>
      <ActionModal
        title={t('volunteering.actionsMenu.cancelOpportunity.cancelOpportunityModal.title')}
        primaryButtonText={t('button.confirm')}
        secondaryButtonText={t('button.cancel')}
        handleClose={onClose}
        handleSubmit={cancelOpportunity}
        loading={isLoading}
        buttonShape="default"
      >
        <Trans
          i18nKey="volunteering.actionsMenu.cancelOpportunity.cancelOpportunityModal.description"
          values={{ opportunityName }}
        />
      </ActionModal>
    </Modal>
  )
}
